import type { amendes as Fr } from '../fr/amendes';

/** « amendes » in English — typed on the French: a missing sentence does not compile. */
export const amendes: typeof Fr = {
  erreur: 'Error',
  titre: 'Fines',
  sousTitre: 'Automatically matched to whoever was driving on that date — clause 07',
  enregistrer: 'Record a fine',
  rattachee: (n: string) => `Matched to ${n}`,
  aucuneLocation: 'No rental on that date',
  retrouve: (nom: string) => `The driver on that day was found: ${nom}. The fine is marked “to recharge”.`,
  chargeAgence: 'No customer was driving this vehicle on that date: the agency pays the fine.',
  aRefacturer: (m: string) => `${m} to recharge to your customers`,
  aRefacturerTexte: (n: number) => `${n} ${n === 1 ? 'fine' : 'fines'} matched to a rental, not yet passed on.`,
  aucune: 'No fines recorded',
  col: { infraction: 'Offence', vehicule: 'Vehicle', conducteur: 'Driver found', pv: 'Ticket no.', montant: 'Amount', statut: 'Status' },
  chargeAgenceCourt: 'paid by the agency',
  statuts: { a_refacturer: 'to recharge', refacturee: 'recharged' },
  aide: 'Enter the date of the offence, not the date you received it: that is what identifies the driver.',
  vehicule: 'Vehicle',
  choisir: 'Choose…',
  date: 'Date of the offence',
  montant: (d: string) => `Amount (${d})`,
  pv: 'Ticket number',
  description: 'Description',
  descriptionExemple: 'Speeding — RN5',
  annuler: 'Cancel',
  rattacher: 'Save and match',
};
